const COVERS = {
  '1': 'https://assets.funliday.com/trip-default-cover/1.png',
  '2': 'https://assets.funliday.com/trip-default-cover/2.png',
  '3': 'https://assets.funliday.com/trip-default-cover/3.png',
  '4': 'https://assets.funliday.com/trip-default-cover/4.png',
  '5': 'https://assets.funliday.com/trip-default-cover/5.png',
  '6': 'https://assets.funliday.com/trip-default-cover/6.png',
  '7': 'https://assets.funliday.com/trip-default-cover/7.png',
  '8': 'https://assets.funliday.com/trip-default-cover/8.png',
  '9': 'https://assets.funliday.com/trip-default-cover/9.png',
  '10': 'https://assets.funliday.com/trip-default-cover/10.png',
  '11': 'https://assets.funliday.com/trip-default-cover/11.png',
  '12': 'https://assets.funliday.com/trip-default-cover/12.png',
  '13': 'https://assets.funliday.com/trip-default-cover/13.png',
  '14': 'https://assets.funliday.com/trip-default-cover/14.png',
  '15': 'https://assets.funliday.com/trip-default-cover/15.png',
  '16': 'https://assets.funliday.com/trip-default-cover/16.png',
  '17': 'https://assets.funliday.com/trip-default-cover/17.png',
  '18': 'https://assets.funliday.com/trip-default-cover/18.png',
  '19': 'https://assets.funliday.com/trip-default-cover/19.png',
  '20': 'https://assets.funliday.com/trip-default-cover/20.png',
  '21': 'https://assets.funliday.com/trip-default-cover/21.png',
  '22': 'https://assets.funliday.com/trip-default-cover/22.png',
  '23': 'https://assets.funliday.com/trip-default-cover/23.png',
  '24': 'https://assets.funliday.com/trip-default-cover/24.png',
  '25': 'https://assets.funliday.com/trip-default-cover/25.png',
  '26': 'https://assets.funliday.com/trip-default-cover/26.png',
  '27': 'https://assets.funliday.com/trip-default-cover/27.png',
  '28': 'https://assets.funliday.com/trip-default-cover/28.png',
  '29': 'https://assets.funliday.com/trip-default-cover/29.png',
  '30': 'https://assets.funliday.com/trip-default-cover/30.png',
  '31': 'https://assets.funliday.com/trip-default-cover/31.png',
  '32': 'https://assets.funliday.com/trip-default-cover/32.png',
  '33': 'https://assets.funliday.com/trip-default-cover/33.png',
  '34': 'https://assets.funliday.com/trip-default-cover/34.png',
  '35': 'https://assets.funliday.com/trip-default-cover/35.png',
  '36': 'https://assets.funliday.com/trip-default-cover/36.png',
  '37': 'https://assets.funliday.com/trip-default-cover/37.png',
  '38': 'https://assets.funliday.com/trip-default-cover/38.png',
  '39': 'https://assets.funliday.com/trip-default-cover/39.png',
  '40': 'https://assets.funliday.com/trip-default-cover/40.png',
  '41': 'https://assets.funliday.com/trip-default-cover/41.png',
  '42': 'https://assets.funliday.com/trip-default-cover/42.png',
  '43': 'https://assets.funliday.com/trip-default-cover/43.png',
};

/**
 *
 * @param {string} coverNumber
 * @returns
 */
export const getTripCoverUrlByNumber = coverNumber => {
  if (!coverNumber) {
    return '';
  }

  return COVERS[coverNumber];
};
